import client from "./_client";

const endpointV1 = `/v1/feedbacks`;

export const postFeedback = (reportBody) => client.post(endpointV1, reportBody);

export const getUserFeedbacks = ({ page, limit = 8 }) =>
  client.get(endpointV1 + `/user?page=${page}&limit=${limit}`);

export const isUserFeedbackExist = (courseId, type) =>
  client.get(endpointV1 + `?courseId=${courseId}&type=${type}`);

export const getBatchQueries = ({
  batchId,
  page = 1,
  limit = 10,
  filter = "all",
}) =>
  client.get(
    `${endpointV1}/batch/support?id=${batchId}&page=${page}&limit=${limit}&filter=${filter}`
  );

export const replyToQuery = ({ id, message }) =>
  client.patch(`${endpointV1}/batch/support/reply`, { id: id, message });

export const markQueryAsRead = ({ id }) =>
  client.patch(`${endpointV1}/batch/support/read?feedbackId=${id}`);

export const getSupportUnreadCount = ({ batchId }) =>
  client.get(`${endpointV1}/batch/support/unread?batchId=${batchId}`);
